import React from 'react';
import { Box } from '@mui/material';
import { OnlineLayoutSettings } from 'common/modules/customization';
import CategoryListingView from './CategoryListingView';
import ProductListingView from './ProductListingView';

export interface Props {
	layoutSettings: OnlineLayoutSettings;
}
const HomePreview = (props: Props) => {
	const { layoutSettings } = props;
	const { productGridColumns, featuredImage, defaultLayout } = layoutSettings;
	const isProductsLayout = defaultLayout === 'products';
	const gridColumns = productGridColumns?.desktop;

	return (
		<Box
			mt={4}
			sx={{
				display: 'flex',
				flexDirection: isProductsLayout ? 'row' : 'column',
				maxWidth: '1280px',
				mx: 'auto',
				width: '100%',
			}}
		>
			{isProductsLayout ? (
				<ProductListingView gridColumns={gridColumns} />
			) : (
				<CategoryListingView gridColumns={gridColumns} featuredImage={featuredImage} />
			)}
		</Box>
	);
};

export default HomePreview;
